import Resource from '@/api/resources/Resource'

class SampleDiagnosisService extends Resource {
    async findById(labId, casId, samId) {
        return this.axios.get(`/laboratories/${labId}/cases/${casId}/samples/${samId}/diagnosis`)
            .then(response => response.data)
    }

    async updateDescription(labId, casId, samId, description) {
        return this.axios.put(`/laboratories/${labId}/cases/${casId}/samples/${samId}/diagnosis`, description)
            .then(response => response.data)
    }

    async updateDescriptionAndSolveCodificationsChange(laboratoryId, caseId, sampleId, description, replaceInsteadOfAdd) {
        const params = { replaceInsteadOfAdd }
        const response = await this.axios.put(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/diagnosis/solveCodificationsChange`, description, { params })
        return response.data
    }
}

export default new SampleDiagnosisService()
